import { httpCreate } from './http';

const http = httpCreate('/shop/api/product-activity/');

export const productActivity = {
	saveProductList(activityId, ids) {
		return http.post(`${activityId}`, ids);
	},
	getCheckedList(activityId, params) {
		return http.get(`${activityId}`, { params });
	},
	getGoodlistInLive(activityId, params) {
		return http.get(`${activityId}/page`, { params });
	},
	// 标记/取消推荐
	signReco(activityId, proId, isReco) {
		return http.post(`/signReco/${activityId}/${proId}/${isReco}`);
	},
	// 推送
	pushProduct(activityId, proId) {
		return http.post(`/push/${activityId}/${proId}`);
	},
	deleteProduct(activityId, proId) {
		return http.delete(`/${activityId}/${proId}`);
	},
};
